var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"our-casino"},[_c('AllGames',{attrs:{"title":"WorldcupsportsCASINO","showTopBolts":false,"showBottomBolts":false,"showPlayButton":false,"showSeeAll":false,"filteredGameNames":['Mines', 'Crash', 'Tower', 'BlackJack'],"largeCards":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }